import { observer } from "mobx-react-lite";
import React from "react";
import { YStack } from "tamagui";
import { useApi } from "../../../core/apis";
import { useStores } from "../../../core/stores";
import { CenterContent } from "../../../ui/CenterContent";
import { LoadingCircular } from "../../../ui/LoadingCircular";
import type { BusinessFeedItem } from "../BusinessFeedItem";

export type FeedItemBusinessModuleStatusData = {
  businessModuleUid: string;
};

export const FeedItemBusinessModuleStatusUI = observer(
  ({ item }: { item: BusinessFeedItem }) => {
    const itemData = item.data.itemData as FeedItemBusinessModuleStatusData;

    const { businessModulesStore } = useStores();
    const { businessModulesApi } = useApi();

    const businessModule = businessModulesStore.byId.get(
      itemData.businessModuleUid,
    );

    React.useEffect(() => {
      if (!businessModulesStore.byId.get(itemData.businessModuleUid)) {
        void businessModulesApi.getById(itemData.businessModuleUid);
      }
    }, [itemData.businessModuleUid, businessModulesApi, businessModulesStore]);

    if (!item.businessPlan || !businessModule)
      return (
        <CenterContent>
          <LoadingCircular />
        </CenterContent>
      );

    return <YStack gap={"$medium"}>{businessModule.renderFeedItem()}</YStack>;
  },
);
